import React from "react";
import { images } from "@img/imagesMap";

interface WeeklyOffSearchBarProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

export default function WeeklyOffSearchBar({
  searchTerm,
  onSearchChange,
  onSearchKeyDown,
  onSearch,
}: WeeklyOffSearchBarProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-[14px] rounded-lg">
      <div className="flex-1 relative">
        <span className="text-sm text-[#B8B8BF]">
          <span className="underline underline-offset-2">*</span>
          <span className="underline underline-offset-2">근무자 관리</span>
          {` `}페이지에서 근무자 개별 수동 설정 가능
        </span>
      </div>
      <div className="flex items-center gap-2">
        <div className="relative">
          <input
            type="text"
            placeholder="이름으로 검색"
            value={searchTerm}
            onChange={onSearchChange}
            onKeyDown={onSearchKeyDown}
            className="font-pretendard rounded-full w-64 px-[20px] py-[10px] border border-gray-300 text-sm text-[#333333] placeholder-[#939399] focus:outline-none focus:ring-2 focus:ring-[#0e59c6] focus:border-transparent"
          />

          <button
            onClick={onSearch}
            className="absolute right-[20px] top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            <img
              src={images.icon_search}
              alt=""
              className=""
              style={{ height: "1em" }}
            />
          </button>
        </div>
      </div>
    </div>
  );
}
